import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import { Link } from "react-router-dom";
import {
  closeModal,
  formatTime,
  ToastMain,
  SweetAlertShow,
} from "../master/Master";
import {
  CreateSchedule,
  DeleteSchedule,
  ScheduleList,
  UpdateSchedule,
} from "../../api/TimeTableService";
import Swal from "sweetalert2";
import TimeTableHeader from "./Master";
import Master from "./Master";

export default function Schedule() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState("");
  const [error, setError] = useState("");

  const getScheduleList = async () => {
    setLoading(true);
    try {
      const response = await ScheduleList();

      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const createSchedule = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await CreateSchedule(formData);
      if (response?.data?.status) {
        setError("");
        closeModal("createNewSchedule");
        getScheduleList();
        e.target.reset();
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Create Successfully!",
        // });

        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const updateSchedule = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await UpdateSchedule(formData);
      if (response?.data?.status) {
        setError("");
        getScheduleList();
        closeModal("updateSchedule");
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Successfully!",
        // });

        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    }
  };

  const deleteSchedule = async (id) => {
    setLoading(true);
    try {
      const response = await DeleteSchedule(id);
      if (response?.data?.status) {
        getScheduleList();
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Successfully!",
        // });

        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Went Wrong!",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getScheduleList();
  }, []);
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <Master />
                  <div className="col-md-12">
                    <div className="card p-3 mb-3 shadow-sm border-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            style={{
                              width: 45,
                              height: 45,
                              borderRadius: "12px",
                              background:
                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i className="ri-calendar-schedule-line"></i>
                          </div>

                          <div>
                            <h5 className="m-0 fw-bold">Schedule</h5>
                            <small>School Periods & Class Timetable </small>
                          </div>
                        </div>
                        {hasAccess("/schedule/add") && (
                          <div className="d-flex align-items-center gap-2">
                            <Link
                              data-bs-toggle="modal"
                              data-bs-target="#createNewSchedule"
                              className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: 40, height: 40 }}
                            >
                              <i className="ri-add-line"></i>
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover text-nowrap">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Duration (In Mints)</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item?.title}</td>
                                  <td>{formatTime(item?.start_time)}</td>
                                  <td>{formatTime(item?.end_time)}</td>
                                  <td>{item?.duration} Mints</td>
                                  <td>
                                    {item?.status == "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </td>
                                  <td>
                                    <div className="d-inline-flex align-items-center justify-content-center gap-2">
                                      {hasAccess("/schedule/edit") && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "36px",
                                            height: "36px",
                                            padding: 0,
                                          }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#updateSchedule"
                                          onClick={() => setModalData(item)}
                                          title="Edit Schedule"
                                        >
                                          <i
                                            className="ri-pencil-line"
                                            style={{
                                              fontSize: "18px",
                                              lineHeight: 1,
                                            }}
                                          ></i>
                                        </button>
                                      )}
                                      {hasAccess("/schedule/delete") && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "36px",
                                            height: "36px",
                                            padding: 0,
                                          }}
                                          onClick={() =>
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "This action will permanently delete the Schedule!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#d33",
                                              cancelButtonColor: "#6c757d",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                              cancelButtonText: "Cancel",
                                            }).then(async (result) => {
                                              if (result.isConfirmed) {
                                                deleteSchedule(item?.id);
                                              }
                                            })
                                          }
                                          title="Delete Schedule"
                                        >
                                          <i
                                            className="ri-delete-bin-line"
                                            style={{
                                              fontSize: "18px",
                                              lineHeight: 1,
                                            }}
                                          ></i>
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="createNewSchedule"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={createSchedule}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Create Schedule
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control input-capitalize"
                        placeholder="title"
                        name="title"
                      />
                      <label className="">Title</label>
                      <span className="text-danger">{error?.title ?? ""}</span>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        placeholder="start time"
                        name="start_time"
                      />
                      <label className="">Start Time</label>
                      <span className="text-danger">
                        {error?.start_time ?? ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        rows="2"
                        placeholder="end_time"
                        name="end_time"
                      />
                      <label className="">End Time</label>
                      <span className="text-danger">
                        {error?.end_time ?? ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="updateSchedule"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={updateSchedule}>
              <div className="modal-header bg-label-primary py-3">
                <h3 className="modal-title fs-5" id="exampleModalLabel">
                  Update Schedule
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <input
                      type="hidden"
                      className="form-control"
                      name="id"
                      value={modalData?.id}
                    />
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control input-capitalize"
                        placeholder="title"
                        name="title"
                        defaultValue={modalData?.title}
                      />
                      <label className="">Title</label>
                      <span className="title">{error?.title ?? ""}</span>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        placeholder="start time"
                        name="start_time"
                        defaultValue={modalData?.start_time}
                      />
                      <label className="">Start Time</label>
                      <span className="title">{error?.start_time ?? ""}</span>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        rows="2"
                        placeholder="end_time"
                        name="end_time"
                        defaultValue={modalData?.end_time}
                      />
                      <label className="">End Time</label>
                      <span className="title">{error?.end_time ?? ""}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
